import {
  FixedScreenHeaderStack,
  SearchAndAddBar,
} from '~/common/components/defaultUIComponents';
import { DefaultModalDialog } from '~/common/components/defaultUIComponents/defaultModalDialog';
import { InputField } from '~/common/components/defaultUIComponents/InputField';
import { useDepartmentService } from '~/common/services/DepartmentService';
import { Heading } from '~/common/components/defaultUIComponents/Heading';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { DepartmentContextProvider } from './departmentContext';
import { ListView } from '~/common/components/ListView';
import { Divider, Flex, Stack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import DepartmentTile from './DepartmentTile';
import _ from 'lodash';

export const DepartmentScreen: React.FC = () => {
  const [openDepartment, setOpenDepartment] = useState<number>();
  const [showAddDepartment, setShowAddDepartment] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const departmentService = useDepartmentService();

  useEffect(() => {
    void departmentService.fillStoreWithServerData();
    void EmployeeApi.queries.getEmployees();
  }, [departmentService]);

  const { departments } = departmentService;

  type NewDepartmentValues = {
    name: string;
    description: string;
  };

  const toggleShowAddDepartment = () => {
    setShowAddDepartment(!showAddDepartment);
  };

  const onAddDepartmentModalAction = (values: NewDepartmentValues) => {
    void departmentService.addDepartment(
      values.name,
      values.description,
      toggleShowAddDepartment,
    );
  };

  return (
    <>
      <DefaultModalDialog
        dialogHeaderText="department.addDepartment.dialogHeaderText"
        submitText="department.addDepartment.submitText"
        isOpen={showAddDepartment}
        onCancel={toggleShowAddDepartment}
        onSubmit={onAddDepartmentModalAction}
        showCancelButton
        size="xl"
        initialValues={
          {
            name: '',
            description: '',
          } as NewDepartmentValues
        }
      >
        <Flex direction="column">
          <InputField
            name="name"
            label=""
            placeholder="department.addDepartment.input.name.placeholder"
            mb={5}
          />
          <InputField
            name="description"
            label=""
            placeholder="department.addDepartment.input.description.placeholder"
            textarea
          />
        </Flex>
      </DefaultModalDialog>
      <DepartmentContextProvider value={{ openDepartment, setOpenDepartment }}>
        <FixedScreenHeaderStack>
          <Heading>department.heading</Heading>
          <SearchAndAddBar
            onInputChange={setSearchTerm}
            onClick={toggleShowAddDepartment}
            inputPlaceholder="department.searchDepartments.input.placeholder"
            tooltipLabel="department.newDepartment.tooltip.label"
          />
        </FixedScreenHeaderStack>
        <ListView
          data={departments}
          searchFields={(d) => [d.name]}
          search={searchTerm}
          render={({ data }) => {
            return (
              <>
                <Stack mt={5}>
                  {_.orderBy(data, [(d) => d.name], 'asc').map((department) => (
                    <React.Fragment key={department.id}>
                      <DepartmentTile
                        key={department.id}
                        department={department}
                      />
                      <Divider borderColor="gray.400" />
                    </React.Fragment>
                  ))}
                </Stack>
              </>
            );
          }}
        />
      </DepartmentContextProvider>
    </>
  );
};
